import { __assign, __extends } from "tslib";
import { add } from './add';
import { GregorianDate } from './gregorian';
var ZEROS = { year: 1, month: 1, day: 1, hour: 0, minute: 0, second: 0, millis: 0 };
/**
 * A date in the Buddhist calendar.
 *
 * type: buddhist
 *
 * @public
 */
var BuddhistDate = /** @class */ (function (_super) {
    __extends(BuddhistDate, _super);
    function BuddhistDate(firstDay, minDays) {
        return _super.call(this, 'buddhist', firstDay, minDays) || this;
    }
    BuddhistDate.prototype.set = function (fields) {
        return this._set(__assign(__assign({}, this.fields()), fields));
    };
    BuddhistDate.prototype.add = function (fields) {
        var _a = add(this, fields), jd = _a[0], ms = _a[1];
        return this._new().initFromJD(jd, ms, this.timeZoneId());
    };
    BuddhistDate.prototype.withZone = function (zoneId) {
        return this._new().initFromUnixEpoch(this.unixEpoch(), zoneId);
    };
    BuddhistDate.prototype.toString = function () {
        return this._toString('Buddhist');
    };
    BuddhistDate.fromFields = function (fields, firstDay, minDays) {
        return new BuddhistDate(firstDay, minDays)._set(__assign(__assign({}, ZEROS), fields));
    };
    BuddhistDate.fromUnixEpoch = function (epoch, zoneId, firstDay, minDays) {
        return new BuddhistDate(firstDay, minDays).initFromUnixEpoch(epoch, zoneId);
    };
    BuddhistDate.prototype._new = function () {
        return new BuddhistDate(this._firstDay, this._minDays);
    };
    BuddhistDate.prototype.initFromUnixEpoch = function (epoch, zoneId) {
        _super.prototype.initFromUnixEpoch.call(this, epoch, zoneId);
        computeBuddhistFields(this._fields);
        return this;
    };
    BuddhistDate.prototype.initFromJD = function (jd, msDay, zoneId) {
        _super.prototype.initFromJD.call(this, jd, msDay, zoneId);
        computeBuddhistFields(this._fields);
        return this;
    };
    return BuddhistDate;
}(GregorianDate));
export { BuddhistDate };
var computeBuddhistFields = function (f) {
    f[2 /* DateField.ERA */] = 0;
    f[4 /* DateField.YEAR */] = f[3 /* DateField.EXTENDED_YEAR */] - -543 /* CalendarConstants.BUDDHIST_ERA_START */;
};
//# sourceMappingURL=buddhist.js.map